export default (async function ({ store, $auth }) {
    if (store.state.settings.settings === null && $auth.loggedIn) {
        await store.dispatch('settings/loadSettings');
    }
});
